import React, { SVGProps } from 'react';

export const IconBriefcase = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M2 13h20" />
  </svg>
);

export const IconCalendarCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 10h18M8 3v4M16 3v4" />
    <path d="M9 15l2 2 4-4" />
  </svg>
);

export const IconReceipt = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M5 2h12a1 1 0 0 1 1 1v18l-3-2-3 2-3-2-3 2-3-2V3a1 1 0 0 1 1-1z" />
    <path d="M8 8h8M8 12h6M8 16h4" />
  </svg>
);

export const IconBankColumns = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M3 10l9-6 9 6" />
    <path d="M3 10h18" />
    <path d="M5 10v9M9 10v9M15 10v9M19 10v9" />
    <path d="M3 21h18" />
  </svg>
);

export const IconStackedCoins = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <ellipse cx="12" cy="6" rx="8" ry="2.5" />
    <path d="M4 6v4c0 1.38 3.58 2.5 8 2.5s8-1.12 8-2.5V6" />
    <path d="M4 10v4c0 1.38 3.58 2.5 8 2.5s8-1.12 8-2.5v-4" />
    <path d="M4 14v4c0 1.38 3.58 2.5 8 2.5s8-1.12 8-2.5v-4" />
  </svg>
);

export const IconOfficeBuilding = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="4" y="3" width="16" height="18" rx="1" />
    <path d="M9 7h.01M15 7h.01M9 11h.01M15 11h.01M9 15h.01M15 15h.01" />
    <path d="M10 21v-4h4v4" />
  </svg>
);

export const IconClipboardSign = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="5" y="4" width="14" height="18" rx="1.5" />
    <path d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1" />
    <path d="M9 4h6" />
    <path d="M9 11h6M9 14h6" />
    <path d="M9 18c1-1 2.5-1 3.5 0s2.5 1 3.5 0" />
  </svg>
);

export const IconStatHoliday = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 10h18M8 3v4M16 3v4" />
    <path d="M12 13l1.4 2.9 3.1.3-2.3 2.1.7 3-2.9-1.6-2.9 1.6.7-3-2.3-2.1 3.1-.3z" />
  </svg>
);